import {
  withDefaultContextAsHomeGeo,
  withDefaultContextAsSelectedProject,
} from './api-default-context';

export const getStatementRequest = (
  statementId,
  { contextKey, contextValue } = {
    contextKey: undefined,
    contextValue: undefined,
  },
) =>
  withDefaultContextAsSelectedProject({ contextKey, contextValue }).get(
    `/tieout/statements/${statementId}`,
  );

export const getStatementWorkflowStepsMetaData = () => {
  return withDefaultContextAsHomeGeo()
    .get('/tieout/documentupload/workflows/steps')
    .then((response) => {
      return response;
    });
};

export const getLinkedStatements = ({ statementId, projectId, revisionId }) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/client/${parseInt(
        projectId,
      )}/statement/${statementId}/revision/${revisionId}/autotieout/linked-statements`,
    )
    .then((response) => {
      return response;
    });
};

export const unLinkedStatement = (autoTieoutStatementDetails) => {
  const { targetStatementId, targetRevisionId } = autoTieoutStatementDetails;
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/statements/${targetStatementId}/revisions/${targetRevisionId}/autotieout/unlink-statement`,
      { ...autoTieoutStatementDetails },
    )
    .then((response) => {
      return response;
    });
};

export const cancelAutoTieoutStatementProcessing = (autoTieoutStatementDetails) => {
  const { targetClientId, targetStatementId, targetRevisionId, sourceStatementId, sourceRevisionId } = autoTieoutStatementDetails;
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/client/${parseInt(targetClientId)}/statements/source/${sourceStatementId}/target/${targetStatementId}/revisions/source/${sourceRevisionId}/target/${targetRevisionId}/autotieout/workflow/cancel`
    )
    .then((response) => {
      return response;
    });
};

export const importOmniaDetails = ({ clientId, statementId, revisionId }) => {
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/import`,
    )
    .then((response) => {
      return response;
    });
};

export const getOmniaSnapshotDetails = ({
  clientId,
  statementId,
  revisionId,
}) => {
  return withDefaultContextAsSelectedProject()
    .get(
      `/tieout/trialbalance/client/${clientId}/statement/${statementId}/revision/${revisionId}/trial-balance-data`,
    )
    .then((response) => {
      return response;
    });
};

export const unlinkOmniaSnapshotStatement = ({
  clientId,
  statementId,
  revisionId,
}) => {
  return withDefaultContextAsSelectedProject()
    .post(
      `/tieout/trialbalance/client/${clientId}/statements/${statementId}/revision/${revisionId}/unlink-statement`,
    )
    .then((response) => {
      return response;
    });
};
